<div class="auth-page flex min-h-dvh flex-col px-4 py-6 sm:px-6 md:px-8 md:py-8">
    <header class="flex justify-start">
        <img
            class="h-12 w-auto"
            src="images/ai-arcs-logo-black.png"
            [alt]="productName"
            data-testid="auth-brand"
        />
    </header>

    <main class="flex flex-1 items-center justify-center py-6">
        <div
            class="w-full max-w-[440px] rounded-[20px] bg-[var(--background-card)] p-6 shadow-[var(--auth-card-shadow)] sm:rounded-[24px] sm:p-10"
        >
            <router-outlet />
        </div>
    </main>

    <footer class="flex justify-center pt-8 text-[13px] font-medium">
        <a
            class="text-[var(--text-color-secondary)] hover:text-primary-700 hover:underline"
            [href]="'mailto:' + supportEmail"
            data-testid="auth-help-link"
        >
            Need help?
        </a>
    </footer>
</div>
